import { ButtonGroup, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

// TODO: Not clear in mockup. DarkBlue style for first group button or active button?
const useStyles = makeStyles(theme => {
  const colors = theme.palette;

  return {
    root: {
      display: 'flex',
      '& .group-button': {
        flexGrow: '1',
        border: `1px solid`,
        borderRadius: '0',
        borderColor: colors.grey.medium,
        color: colors.primary.main,
        textTransform: 'none',
        '&:hover:not(:first-child)': {
          backgroundColor: colors.accent.light,
          borderColor: colors.accent.main
        },
        '&:first-child': {
          color: colors.white,
          borderRadius: '4px 0 0 4px',
          borderColor: colors.primary.main,
          backgroundColor: colors.primary.main
        },
        '&:last-child': {
          borderRadius: '0 4px 4px 0'
        },
        '&:only-child': {
          borderRadius: '4px'
        }
      }
    }
  };
});

const ThemeButtonGroup = ({ size, children }) => {
  const classes = useStyles();
  return (
    <ButtonGroup size={size} className={classes.root}>
      {children}
    </ButtonGroup>
  );
};

ThemeButtonGroup.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.node.isRequired
};

ThemeButtonGroup.defaultProps = {
  size: 'large'
};

export default ThemeButtonGroup;
